// extracted by mini-css-extract-plugin
export default {"element":"List_element__ZbhNN","right":"List_right__5JmN3","pic":"List_pic__tpDoT","text":"List_text__E1lWj","desc":"List_desc__URb7d","left":"List_left__qVwZb"};